/**
 * @copyright 2019 @ DigiNet
 * @author TRIHAO
 * @create 9/16/2020
 * @Example
 */

import React from 'react';
import Config from "../../config";
import ReactLoading from 'react-loading';
import {Typography, withStyles} from "@material-ui/core";
import queryString from 'query-string'
import {connect} from "react-redux";
import {bindActionCreators, compose} from "redux";
import * as userActions from "../../actions/user-actions";

const styles = {
    content: {
        textAlign: "center",
        padding: 15
    }
};
class AuthPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    };

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.loading !== this.props.loading && !this.props.loading) {
            this.checkAuth();
        }
    }

    checkAuth = () => {
        const query = queryString.parse(window.location.search);
        const {token, lang} = query;
        const params = {
            Language: lang || Config.language || "84",
            token: token ? token : ""
        };
        Config.getToken = true;
        this.props.userActions.getAuth(params, (error, data)=>{
            if (error){
                let message = error.message || Config.lang("ERP_Loi_chua_xac_dinh");
                Config.popup.show("INFO", message);
                return false;
            }
            if (data) {
                this.onLogin(data);
            }
        });
    };

    onLogin = (data) => {
        let user = data.user || {};
        const expire = new Date().getTime() + 7*24*60*60*1000;

        Config.token = {
            id: data.token,
            expire: expire
        };

        user.type = 2;
        if(Config.localization!==null){
            Config.localization.setLanguage("vi");
            Config.setLocalStorage("langCRM", "vi");
        }

        Config.setLocalStorage('PROFILE', Config.encryptData(JSON.stringify(user)));
        Config.setLocalStorage('TOKEN', JSON.stringify(Config.token));

        this.setState({UserTracking: user}, () => {

            setTimeout(()=>{
                this.setState({isSubmit: false, message: ''});
                this.redirectScreen();
            }, 1000);
        });
    };

    redirectScreen = () => {
        let query = queryString.parse(window.location.search);
        const {route} = query;
        if (query?.token) delete query.token;
        let pathname = route ? route : "/";
        pathname = pathname.indexOf("/") === 0 ? pathname.substring(1) : pathname;
        const pathinfo = {
            pathname: Config.getRootPath() + pathname,
            state: {...query}
        };
        Config.setLocalStorage('AUTHREDIRECT', JSON.stringify(pathinfo));

        //Custom..
        const {ProductID} = query;
        if (ProductID) {
            Config.setLocalStorage("AUTHPRODUCT", ProductID);
        }

        window.location.reload();
        // browserHistory.push({
        //     pathname: Config.getRootPath() + pathname,
        //     state: voucher_id ? {voucher_id: voucher_id} : null
        // });
    };

    render() {
        const {classes} = this.props;
        let label = "Đang chuyển tiếp, xin vui lòng chờ...";
        if (Config.language === "01") label = "Forward, please wait...";

        return (
            <div className="auth-page">
                <div className={"auth-page-content " + classes.content}>
                    <Typography variant={"h3"}>{label}</Typography>
                    <div className={"display_row align-center valign-middle"}>
                        <ReactLoading type={'bubbles'}
                                      width={'10%'}
                                      color={"#222B45"}
                        />
                    </div>
                </div>
            </div>
        )
    }
}

export default compose(connect(null,
    (dispatch) => ({
        userActions: bindActionCreators(userActions, dispatch)
    })
), withStyles(styles))(AuthPage);
